<template>
  <main>
    <div
      class="bg-white rounded-lg border-b-4 border-h-primary-800 shadow-sm p-5 custom-card"
    >
      <div
        v-if="question?.openQuestion"
        class="bg-h-warning-100 text-h-warning-700 w-fit px-2 py-1 rounded-sm shadow-sm text-sm mb-3"
      >
        {{
          $t("labels.generic", { pt: "Questão aberta", en: "Open question" })
        }}
      </div>

      <div class="flex items-center justify-between">
        <p class="font-bold text-lg break-words w-full">
          {{ question.prompt }}
        </p>
      </div>

      <div v-for="(item, i) in question.items" :key="i" class="mb-5">
        <div class="text-gray-500 my-3 flex items-center gap-1 flex-row">
          <div class="flex flex-row items-start gap-3">
            <span
              v-if="
                question?.type === 'DEFAULT' || question?.type === undefined
              "
              class="font-bold flex items-start"
            >
              <v-icon
                :name="`${
                  item?.id === question?.correctItem?.id
                    ? 'hi-solid-check'
                    : 'hi-x'
                }`"
                :class="`${
                  item?.id === question?.correctItem?.id
                    ? 'text-green-600'
                    : 'text-h-error-400'
                }`"
              />
            </span>

            <i
              v-if="question?.type === 'TRUE_OR_FALSE'"
              :class="[
                item?.correctAnswer
                  ? 'pi pi-check text-green-600'
                  : 'pi pi-times text-h-error-400',
                'mr-2',
              ]"
            >
            </i>

            <p class="font-extrabold w-20">
              Item
              {{
                question?.type === "TRUE_OR_FALSE" ||
                question?.type === undefined
                  ? chooseLetter(i)
                  : i + 1
              }}:
            </p>
          </div>

          <div>
            <p
              v-if="
                question?.type === 'DEFAULT' || question?.type === undefined
              "
              class="break-words max-w-full"
            >
              {{ item?.answerText }}
            </p>
            <p v-else-if="question?.type === 'TRUE_OR_FALSE'">
              <span>{{ item.answerText }}</span>
            </p>
            <p
              v-else-if="question?.type === 'DRAG_AND_DROP'"
              v-html="item?.answerText"
            ></p>
            <p
              v-else-if="question?.type === 'FILL_IN_THE_BLANKS'"
              v-html="item?.answerText"
            ></p>
          </div>
        </div>
      </div>
      <div
        class="flex justify-end items-center gap-3"
        v-if="role === 'TEACHER'"
      >
        <Button
          :id="`btn-edit-question-${questionIndex}`"
          class="btn-simple p-button-sm"
          icon="pi pi-pencil"
          :label="$t('labels.edit')"
          @click="goToQuestion(question.id, question?.type)"
        />
        <Button
          :id="`btn-delete-question-${questionIndex}`"
          class="btn-delete p-button-sm"
          icon="pi pi-trash"
          :label="$t('labels.delete')"
          :loading="loadBtn[questionIndex]"
          @click="
            confirmModal({
              id: question.id,
              index: questionIndex,
              type: question.type,
            })
          "
        />
      </div>
    </div>
    <ConfirmDialog
      :group="`question-${questionIndex}`"
      :style="{ width: '80vw', maxWidth: '700px' }"
    />
  </main>
</template>

<script lang="ts">
import {
  Question,
  QuestionDragDrop,
  QuestionTrueFalse,
  QuestionType,
} from "@/models/quiz.model";

import { defineComponent, PropType } from "vue";

export default defineComponent({
  name: "QuestionCard",
  props: {
    question: {
      type: Object as PropType<Question | QuestionTrueFalse | QuestionDragDrop>,
      required: true,
    },
    questionIndex: {
      type: Number,
      required: true,
      default: 0,
    },
    loadBtn: {
      type: Array as PropType<boolean[]>,
      required: true,
      default: () => [false],
    },
    role: [String],
  },
  emits: ["goToQuestion", "deleteQuestion"],
  methods: {
    goToQuestion(id: string, type: QuestionType = QuestionType.DEFAULT): void {
      this.$emit("goToQuestion", id, type);
    },
    deleteQuestion(event: any) {
      this.$emit("deleteQuestion", event);
    },
    chooseLetter(index): string {
      return String.fromCharCode(65 + index).toUpperCase();
    },
    getCorrectAnswer(value?: boolean): string {
      return this.$t(value ? "question.items.true" : "question.items.false");
    },
    confirmModal(event: {
      id: string;
      index: number;
      type: QuestionType;
    }): void {
      this.$confirm.require({
        message: this.$t("quiz.teacher.deleteMessage"),
        header: this.$t("quiz.teacher.delete"),
        acceptLabel: this.$t("quiz.teacher.buttons.delete"),
        rejectLabel: this.$t("quiz.teacher.buttons.cancel"),
        rejectClass: "btn-outline",
        acceptClass: "btn-primary",
        group: `question-${event.index}`,
        accept: () => {
          this.deleteQuestion(event);
        },
      });
    },
  },
});
</script>

<style lang="scss">
.custom-card {
  word-break: break-all;
  .mention {
    background-color: #f6fafd;
    border-radius: 0.4rem;
    border: 1px solid #79b5e1;
    box-decoration-break: clone;
    color: #79b5e1;
    padding: 0.1rem 0.3rem;
    word-break: break-all;
    line-break: normal;
    line-height: 175%;
  }
}
</style>
